import { render, staticRenderFns } from "./FilterOptionPuddingC.vue?vue&type=template&id=fb367ca2&scoped=true&"
import script from "./FilterOptionPuddingC.vue?vue&type=script&lang=js&"
export * from "./FilterOptionPuddingC.vue?vue&type=script&lang=js&"
import style0 from "./FilterOptionPuddingC.vue?vue&type=style&index=0&id=fb367ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb367ca2",
  null
  
)

export default component.exports